<div *ngFor="let computer of climateComputerList"   >
<kendo-card  *ngIf="computer.ipaddr != '0.0.0.0'"  class="clientlist-card"   >
  <kendo-card-header>
<!--    Has this computer been reset/reboot in last day-->
    <ng-template [ngIf]="computer.uptime >= 0 && computer.uptime < 24*60">
      <span class="k-icon k-i-reset k-color-error k-icon-md"></span>
    </ng-template>

<!--    Make the status for OFFLINE-->
    <ng-template [ngIf]="computer.status == 0">
      <span class="k-icon k-i-warning k-color-error k-icon-md"></span>
    </ng-template>
<!--    Make status for online but no-restinterface (webinfo failed)-->
    <ng-template [ngIf]="computer.status == 1">
      <span class="k-icon k-i-unlink-horizontal k-color-info k-icon-md"></span>
    </ng-template>
<!--    Make status for ONLINE and REST-connected (webinfo was success)-->
    <ng-template [ngIf]="computer.status == 2">
      <span class="k-icon k-i-link-horizontal k-color-success k-icon-md"></span>
    </ng-template>
    <small> Up: {{ (computer.uptime > 0) ? (computer.uptime/60).toFixed(0) : "-" }} hrs</small>
  </kendo-card-header>

  <button kendoButton look="outline" routerLink="/information/{{ computer.name }}" (click)="onActivate($event)" [id]="computer.idNr"  class="k-button large"  [primary]="computer.restIsPossible"    [disabled]="!computer.restIsPossible">
    {{ computer.idNr}}
  </button>
  <small><b>{{ computer.name}}</b></small>
  <small>IP   {{ computer.ipaddr  }} </small>
  <small>Seen {{ computer.lastSeen | date: 'dd/MM/yy HH:mm:ss' }} </small>
</kendo-card>
</div>

<div *ngFor="let computer of climateComputerList"   >
  <kendo-card  *ngIf="computer.ipaddr == '0.0.0.0'"  class="clientlist-card"   >
    <kendo-card-header>
      Not connected
    </kendo-card-header>

    <button kendoButton look="outline" routerLink="/information/{{ computer.name }}" (click)="onActivate($event)" [id]="computer.idNr"  class="k-button large"  [primary]="computer.restIsPossible"    [disabled]="!computer.restIsPossible">
      {{ computer.idNr}}
    </button>
    <small><b>{{ computer.name}}</b></small>
    <small>IP   {{ computer.ipaddr  }} </small>
    <small>Seen {{ computer.lastSeen | date: 'dd/MM/yy HH:mm:ss' }} </small>
  </kendo-card>

</div>
